import { TableColumn } from "react-data-table-component";
import { FileText } from "react-feather";
import { Badges, Btn } from "../../AbstractElements";
import { useNavigate } from "react-router-dom";
import { CustomCellInterFace } from "../../Types/TablesType";

//TYPES
import { ViewCandidatesByStatus } from "../../Types/Applicants/Candidates";

const ActionCell = ({ row }: { row: ViewCandidatesByStatus }) => {
  const navigate = useNavigate();
  const handleView = () => {
    const encoded = btoa(row.application_no.toString());
    navigate(
      `${process.env.PUBLIC_URL}/view-application/${encodeURIComponent(encoded)}`,
    );
  };

  return (
    <div className="d-flex align-items-center gap-2">
      <Btn size="sm" color="primary" className="px-2" onClick={handleView}>
        <FileText size={11} /> View
      </Btn>
    </div>
  );
};

const CustomBadge: React.FC<CustomCellInterFace> = ({ label, color }) => (
  <Badges style={{ width: "105px" }} color={color}>
    {label}
  </Badges>
);

export const ApplicationsTableColumn: TableColumn<ViewCandidatesByStatus>[] = [
  {
    name: "APPL NO",
    selector: (row) => row.application_no,
    sortable: true,
    width: "110px",
    center: false,
  },
  {
    name: "APPLICANT DETAILS",
    selector: (row) => row.full_name,
    cell: (row) => (
      <div style={{ whiteSpace: "pre-line" }}>
        <b>{row.full_name}</b>

        {" \n "}
        {row.birthdate}
        {" || "}
        {row.age}
        {"\n"}
        {row.full_address}
      </div>
    ),
    sortable: true,
    center: false,
  },
  {
    name: "JOB TITLE",
    selector: (row) => row.job_title,
    width: "300px",
    sortable: true,
    center: false,
  },
  {
    name: "STATUS",
    selector: (row) => row.application_status_label,
    cell: (row) => (
      <>
        <CustomBadge
          color={row.status_color}
          label={row.application_status_label.toUpperCase()}
        />
      </>
    ),
    sortable: true,
    width: "150px",
    center: true,
  },
  {
    name: "SUBMITTED ON",
    selector: (row) => row.created_at,
    sortable: true,
    width: "250px",
    center: false,
  },
  {
    name: "APPLICATION AGING",
    selector: (row) => row.updated_at,
    cell: (row) => {
      const isClosed = ["Hired", "Rejected", "Voided", "Cancelled"].includes(
        row.application_status_label,
      );

      return (
        <div style={{ whiteSpace: "pre-line" }}>
          {isClosed
            ? row.updated_by_user + "\n" + row.updated_at
            : row.days_since_submitted}
        </div>
      );
    },
    sortable: true,
    width: "250px",
    center: false,
  },
  {
    name: "ACTION",
    sortable: false,
    width: "100px",
    center: false,
    cell: (row) => <ActionCell row={row} />,
  },
];
